import PropTypes from "prop-types";
import { PerformanceContext } from "./performanceContext";
import { useEffect, useState } from "react";
import axios from "axios";

export default function PerformanceContextProvider({ children }) {
  const [fullAnswerSheet, setFullAnswerSheet] = useState([]);
  const [paginationPerpage, setPaginationPerpage] = useState();
  const [subject, setSubject] = useState([]);
  const [chapter, setChapter] = useState([]);
  const [topic, setTopic] = useState([]);
  // 👉 সব - সঠিক - ভুল - ব্ল্যাংক
  const [currState, setCurrState] = useState("All");

  const [mapSubject, setMapSubject] = useState(new Map());
  const [mapChapter, setMapChapter] = useState(new Map());
  const [mapTopic, setMapTopic] = useState(new Map());

  const apiUrl = import.meta.env.VITE_APP_API;
  const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
    .token.access;

  function getHashedMap(allAnswerSheet, index) {
    const answerSheetMap = new Map();

    for (const obj of allAnswerSheet) {
      let tag = obj.second_tags[index].tag;

      if (!answerSheetMap.has(tag)) {
        answerSheetMap.set(tag, []);
      }

      answerSheetMap.get(tag).push(obj);
    }

    let newAnswerSheetMap = new Map();

    for (const [key, value] of answerSheetMap) {
      if (!newAnswerSheetMap.has(key)) {
        newAnswerSheetMap.set(key, []);
      }

      let correct = 0,
        wrong = 0,
        blank = 0;

      for (const question of value) {
        if (!question.select) {
          blank++;
        } else if (question.select.answer === true) {
          correct++;
        } else {
          wrong++;
        }
      }

      newAnswerSheetMap.get(key).push([correct, wrong, blank]);
    }

    return newAnswerSheetMap;
  }

  useEffect(() => {
    async function getAnswerSheetList() {
      let subjectSet = new Set(subject);
      let chapterSet = new Set(chapter);
      let topicSet = new Set(topic);

      const url = `${apiUrl}/api/exam/did_exam_list`;

      const getAnswerSheet = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });

      if (getAnswerSheet.status === 200) {
        let fullAnswerSheetArr = [];
        let fullAnswerSheetArrSubject = [];

        let fullAnswerSheetArrChapter = [];
        let fullAnswerSheetArrTopic = [];

        // ❌ without filtered variables
        let allAnswerSheetSubject = [];
        let allAnswerSheetChapter = [];
        let allAnswerSheetTopic = [];

        for (const obj of getAnswerSheet.data) {
          let jsonQuestionPaper;

          function JsonParsable() {
            try {
              jsonQuestionPaper = JSON.parse(obj.question_paper);
              return true;
            } catch {
              return false;
            }
          }

          if (JsonParsable() === true) {
            if (jsonQuestionPaper.length > 0) {
              for (const obj of jsonQuestionPaper) {
                fullAnswerSheetArr = [...fullAnswerSheetArr, obj];

                // 🔎 filtering by subject
                if (subject)
                  if (obj.second_tags) {
                    for (const tag of obj.second_tags) {
                      if (tag.type === "subject" && subjectSet.has(tag.value)) {
                        fullAnswerSheetArrSubject = [
                          ...fullAnswerSheetArrSubject,
                          obj,
                        ];
                      }
                    }
                  }

                // ✅ getting all subjects
                if (obj.second_tags) {
                  for (const tag of obj.second_tags) {
                    if (tag.type === "subject") {
                      allAnswerSheetSubject = [...allAnswerSheetSubject, obj];
                    }
                  }
                }

                // 🔎 filtering by chapter
                if (chapter)
                  if (obj.second_tags) {
                    for (const tag of obj.second_tags) {
                      if (tag.type === "chapter" && chapterSet.has(tag.value)) {
                        fullAnswerSheetArrChapter = [
                          ...fullAnswerSheetArrChapter,
                          obj,
                        ];
                      }
                    }
                  }

                // ✅ getting all chapters
                if (obj.second_tags) {
                  for (const tag of obj.second_tags) {
                    if (tag.type === "chapter") {
                      allAnswerSheetChapter = [...allAnswerSheetChapter, obj];
                    }
                  }
                }

                // 🔎 filtering by topic
                if (topic)
                  if (obj.second_tags) {
                    for (const tag of obj.second_tags) {
                      if (tag.type === "topic" && topicSet.has(tag.value)) {
                        fullAnswerSheetArrTopic = [
                          ...fullAnswerSheetArrTopic,
                          obj,
                        ];
                      }
                    }
                  }

                // ✅ getting all chapters
                if (obj.second_tags) {
                  for (const tag of obj.second_tags) {
                    if (tag.type === "topic") {
                      allAnswerSheetTopic = [...allAnswerSheetTopic, obj];
                    }
                  }
                }
              }
            }
          }
        }

        // let answerSheetMapSubject = getHashedMap(allAnswerSheetSubject, 0);
        // let answerSheetMapChapter = getHashedMap(allAnswerSheetChapter, 1);
        // let answerSheetMapTopic = getHashedMap(allAnswerSheetTopic, 2);

        // setMapSubject(answerSheetMapSubject);
        // setMapChapter(answerSheetMapChapter);
        // setMapTopic(answerSheetMapTopic);

        // console.log(
        //   fullAnswerSheetArrSubject,
        //   fullAnswerSheetArrChapter,
        //   fullAnswerSheetArrTopic
        // );

        let answerSheetMapSubject = getHashedMap(allAnswerSheetSubject, 0);
        let answerSheetMapChapter = getHashedMap(allAnswerSheetChapter, 1);
        let answerSheetMapTopic = getHashedMap(allAnswerSheetTopic, 2);

        if (subject.length > 0) {
          answerSheetMapSubject = getHashedMap(fullAnswerSheetArrSubject, 0);

          let newChapter = [];

          for (const obj of fullAnswerSheetArrSubject) {
            if (obj.second_tags) {
              for (const tag of obj.second_tags) {
                if (tag.type === "chapter") {
                  newChapter = [...newChapter, obj];
                }
              }
            }
          }

          let newTopic = [];

          for (const obj of fullAnswerSheetArrSubject) {
            if (obj.second_tags) {
              for (const tag of obj.second_tags) {
                if (tag.type === "topic") {
                  newTopic = [...newTopic, obj];
                }
              }
            }
          }

          answerSheetMapChapter = getHashedMap(newChapter, 1);
          answerSheetMapTopic = getHashedMap(newTopic, 2);
        }

        if (chapter > 0) {
          let newChapter = [];

          for (const obj of fullAnswerSheetArrChapter) {
            if (obj.second_tags) {
              for (const tag of obj.second_tags) {
                if (tag.type === "chapter") {
                  newChapter = [...newChapter, obj];
                }
              }
            }
          }

          let newTopic = [];

          for (const obj of fullAnswerSheetArrChapter) {
            if (obj.second_tags) {
              for (const tag of obj.second_tags) {
                if (tag.type === "topic") {
                  newTopic = [...newTopic, obj];
                }
              }
            }
          }

          answerSheetMapChapter = getHashedMap(newChapter, 1);
          answerSheetMapTopic = getHashedMap(newTopic, 2);
        }

        if (topic > 0) {
          let newTopic = [];

          for (const obj of fullAnswerSheetArrTopic) {
            if (obj.second_tags) {
              for (const tag of obj.second_tags) {
                if (tag.type === "topic") {
                  newTopic = [...newTopic, obj];
                }
              }
            }
          }

          answerSheetMapTopic = getHashedMap(newTopic, 2);
        }

        setMapSubject(answerSheetMapSubject);
        setMapChapter(answerSheetMapChapter);
        setMapTopic(answerSheetMapTopic);
      }
    }

    getAnswerSheetList();
  }, [access_token, chapter, subject, topic, currState, apiUrl]);

  useEffect(() => {
    if (fullAnswerSheet.length > 0) {
      setPaginationPerpage(Math.floor(fullAnswerSheet.length / 20));
    }
  }, [fullAnswerSheet]);

  return (
    <PerformanceContext.Provider
      value={{
        fullAnswerSheet,
        setFullAnswerSheet,
        paginationPerpage,
        setPaginationPerpage,
        setSubject,
        setChapter,
        setTopic,
        currState,
        setCurrState,
        mapSubject,
        setMapSubject,
        mapChapter,
        setMapChapter,
        mapTopic,
        setMapTopic,
      }}
    >
      {children}
    </PerformanceContext.Provider>
  );
}

PerformanceContextProvider.propTypes = {
  children: PropTypes.any,
};
